import * as React from 'react';

export const Column1 = () => (
  <div className="column-1">
    <div className="cell">&nbsp;</div>
  </div>
);
